<div class="header">
  <h1 class="mat-dialog-title">Create new onboarding</h1>
</div>

<mat-dialog-content>
  <app-onboarding-form
    [loading]="loading"
    [displayActions]="false"
    (submitForm)="createOnboarding($event)"
  >
  </app-onboarding-form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button (click)="close()">Cancel</button>
  <button mat-raised-button color="primary" (click)="submit()">Submit</button>
</mat-dialog-actions>
